import React, { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RoutingUtils from '../../../../shared/utils/utils-routing';
import { displayLocalContentProductDetails } from '../../../../store/header/actions';
import { PATH_LOCAL_CONTENT } from '../../../../store/constants';
import { useParams } from 'react-router';
import { AppState } from '../../../../store/appState';
import { AppDispatch } from '../../../../store';
import { useLocalContentProduct } from '../../../../api/local-content/collection/product/useLocalContentProduct';
import { useCountries } from '../../api/useCountries';
import { LCProductDetailReadView } from './LCProductDetailReadView';
import { useDeleteProductCover } from '../../../../api/local-content/collection/product/useDeleteProductCover';
import { useWithdrawLocalContentProduct } from '../../../../api/local-content/collection/product/useWithdrawLocalContentProduct';
import { useSetProductLiveOnLibx } from '../../../../api/local-content/collection/product/useSetProductLiveOnLibx';
import { usePublishLocalContentProduct } from '../../../../api/local-content/collection/product/usePublishLocalContentProduct';
import { useRepublishLocalContentProduct } from '../../../../api/local-content/collection/product/useRepublishLocalContentProduct';
import { useDeactivateLocalContentProduct } from '../../../../api/local-content/collection/product/useDeactivateLocalContentProduct';
import { useSaveLibxSettings } from '../../../../api/local-content/collection/product/useSaveLibxSettings';
import { useDeleteLocalContentProduct } from '../../../../api/local-content/collection/product/useDeleteLocalContentProduct';
import { useReactivateLocalContentProduct } from '../../../../api/local-content/collection/product/useReactivateLocalContentProduct';
import {
    UploadProgressCallback,
    useUploadLocalContentAsset,
    useUploadLocalContentCover
} from '../../../../api/local-content/collection/product/useUploadLocalContentAsset';

export const LCProductDetailReadPage = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch<AppDispatch>();
    const authentication = useSelector((state: AppState) => state.authentication);
    const { data: product, isLoading: isProductLoading } = useLocalContentProduct(id);
    const { data: countries, isLoading: isCountriesLoading } = useCountries({});
    const { mutate: deleteProductCoverMutation } = useDeleteProductCover(id);
    const { mutate: uploadProductCoverMutation } = useUploadLocalContentCover(id);
    const { mutate: uploadProductAssetMutation } = useUploadLocalContentAsset(id);
    const { mutate: withdrawProductMutation } = useWithdrawLocalContentProduct(id);
    const { mutate: setLiveProductMutation } = useSetProductLiveOnLibx(id);
    const { mutate: publishProductMutation } = usePublishLocalContentProduct(id);
    const { mutate: republishProductMutation } = useRepublishLocalContentProduct(id);
    const { mutate: deactivateProductMutation } = useDeactivateLocalContentProduct(id);
    const { mutate: saveLibxSettingsMutation } = useSaveLibxSettings(id);
    const { mutate: deleteLocalContentProductMutation } = useDeleteLocalContentProduct(id);
    const { mutate: reactivateLocalContentProductMutation } = useReactivateLocalContentProduct(id);
    const loading = isProductLoading || isCountriesLoading;

    useLayoutEffect(() => {
        dispatch(displayLocalContentProductDetails());
    }, [dispatch]);

    function onUploadNewCover(asset: File, uploadProgressCallback: UploadProgressCallback, closeDialog: () => void) {
        uploadProductCoverMutation(
            { asset, uploadProgressCallback },
            {
                onSuccess: () => {
                    closeDialog();
                }
            }
        );
    }

    function onUploadNewAsset(asset: File, uploadProgressCallback: UploadProgressCallback, closeDialog: () => void) {
        uploadProductAssetMutation(
            { asset, uploadProgressCallback },
            {
                onSuccess: () => {
                    closeDialog();
                }
            }
        );
    }

    function onDeleteProduct() {
        deleteLocalContentProductMutation();
        routeToYourTitlesView();
    }

    function routeToYourTitlesView() {
        RoutingUtils.pushUrl(`${PATH_LOCAL_CONTENT}/products`);
    }

    return (
        <>
            <LCProductDetailReadView
                loading={loading}
                product={product ?? {}}
                onUploadNewAsset={onUploadNewAsset}
                onUploadNewCover={onUploadNewCover}
                onDeleteCover={deleteProductCoverMutation}
                authentication={authentication}
                countries={countries ?? []}
                onDeleteProduct={onDeleteProduct}
                onWithdrawProduct={withdrawProductMutation}
                onSetLiveOnLibx={setLiveProductMutation}
                onDeactivateProduct={deactivateProductMutation}
                onReactivateProduct={reactivateLocalContentProductMutation}
                publishProduct={publishProductMutation}
                republishProduct={republishProductMutation}
                onSaveLibxSettings={saveLibxSettingsMutation}
            />
        </>
    );
};
